// extracted by mini-css-extract-plugin
export default {"button":"UploadFile_button__EhpT4","input":"UploadFile_input__9-46W"};